import React, { useState, useContext, useEffect } from 'react';
import {
  Button,
  Icon,
  SnackbarContext,
  Toolbar,
  Panel,
} from '@fanadise/common-ui';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { ArrowSmLeftIcon } from '@heroicons/react/solid';
import EditAccountForm from 'components/accounts/EditAccountForm';
import { Account } from '@fanadise/common-types';
import { Translate, useTranslation } from '@fanadise/common-logic';
import { accountsApi } from '@fanadise/common-data-access';

// import AccountDomainSection from 'components/accounts/AccountDomainSection';

const AccountsRouteEdit: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams() as { id: string };
  const { translate } = useTranslation();
  const { addErrorAlert } = useContext(SnackbarContext)!;
  const [account, setAccount] = useState<Account>();

  useEffect(() => {
    const fetchAccount = async () => {
      try {
        setAccount(await accountsApi.fetchAccount(id));
      } catch (err: any) {
        addErrorAlert(err.message || translate('error:default'));
        navigate('../');
      }
    };

    fetchAccount();
  }, [id]);

  return (
    <>
      <Toolbar
        title={<Translate id="accounts:edit:title" />}
        leading={
          <Link to="../">
            <Button
              tag="span"
              variant="icon"
              icon={<Icon icon={ArrowSmLeftIcon} size="lg" />}
            />
          </Link>
        }
        mb="8"
      />

      {account && (
        <Panel>
          <EditAccountForm account={account} onChange={setAccount} />
          {/* <AccountDomainSection
            accountId={account.id}
            domain={account.domain}
            onUpdate={setAccount}
          /> */}
        </Panel>
      )}
    </>
  );
};

export default AccountsRouteEdit;
